import React from "react";
import type { ApolloClient } from "@apollo/client";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { FiStar } from "react-icons/fi";
import { push } from "store/actions/router";
import { accountTypesToEnglishMapping } from "statics/accountTypes";
import { find, get, isEmpty } from "lodash";
import { setAccountSession } from "actions/accountActions";
import { activeRolloverIsMixed } from "store/selectors/user";
import type { RootState } from "types/state";

import Button from "components/Button";
import IconBanner from "components/IconBanner";

const mapStateToProps = (state: RootState) => {
  // userState slice is typed `object`; original reads `.state` off it
  const userState = (state.user.userState as { state?: unknown }).state;
  const accounts = state.accounts.iraAccounts;
  const rolloverAccount = find(accounts, { isRollover: true });
  const accountType = get(rolloverAccount, "accountType", null);
  const account = find(accounts, {
    isProcessingRollover: false,
    state: "AccountActive",
    isRollover: true,
  });
  const accountId = account ? account.id : null;
  const isRolloverIsMixed = activeRolloverIsMixed(state);

  return {
    accountId,
    userState,
    accounts,
    accountType,
    isRolloverIsMixed,
  };
};

const mapDispatchToProps = {
  setAccountSession,
  push,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface OwnProps {
  auth0AccountSessionId?: string;
}

type Props = WithApolloClient<OwnProps & PropsFromRedux>;

class IndividualRolloverFormCard extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const overviewAccountType = get(
      find(this.props.accounts, { id: this.props.accountId }),
      "accountType"
    );

    let title = "";

    if (
      this.props.isRolloverIsMixed &&
      isEmpty(this.props.auth0AccountSessionId)
    ) {
      title = `Good news! Your accounts are now open.`;
    } else if (
      !this.props.isRolloverIsMixed &&
      isEmpty(this.props.auth0AccountSessionId)
    ) {
      title = `Good news! Your ${
        accountTypesToEnglishMapping[
          overviewAccountType as keyof typeof accountTypesToEnglishMapping
        ]
      } account is now open.`;
    } else {
      title = `Good news! Your ${
        accountTypesToEnglishMapping[
          this.props.accountType as keyof typeof accountTypesToEnglishMapping
        ]
      } account is now open.`;
    }

    return (
      <>
        <IconBanner
          icon={<FiStar color="white" stroke="#60A4BF" size={16} />}
          color="primary"
          title={title}
          subheader="To complete the rollover of your funds, please fill out this document and complete next steps."
          actionComponent={
            <Button
              size="sm"
              color="action"
              name="action"
              btnLabel="View Rollover Form"
              onClick={async () => {
                await this.props.setAccountSession(
                  this.props.client as ApolloClient<object>,
                  this.props.auth0AccountSessionId as string
                );
                window.location.search = `?redirect_to=/dashboard/rollover_form`;
              }}
            />
          }
        />
      </>
    );
  }
}

export default connector(withApollo<Props>(IndividualRolloverFormCard));
